module.exports = __webpack_public_path__ + "img/ece94e24b2eb49b6a565ee23ab5d0b97-640.937c6b3c.png";